import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
const includes = ['6 Core Teaching Volumes', '5 Professional Teacher Bonuses', 'Lessons, projects and creative challenges', 'Visual references and technique guides', 'Assessment tools, rubrics and reflection pages', '36-week Art planning roadmap', 'Elementary, Middle School and High School adaptations', 'Printable and projectable digital resources'];
export function ClosingBlock() {
  return <section id="closing" className="w-full scroll-mt-20 bg-navy px-5 py-10 sm:py-20" data-id="element-37" data-mp="1w01d8w7z7jx5">
      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-38" data-mp="1s0aqd3lklnxw">
        <h2 className="font-display text-2xl font-bold leading-tight text-white sm:text-4xl" data-id="element-39" data-mp="1d3a074j1211j">
          Your Next Art Lesson Doesn&apos;t Have to Start From a Blank Page.
        </h2>
        <p className="mt-4 text-lg font-medium text-gold sm:text-xl" data-id="element-40" data-mp="3sl7s82pq06r8">
          6 Core Teaching Volumes + 5 Professional Teacher Bonuses
        </p>
        <p className="mt-4 max-w-xl text-sm leading-relaxed text-white/75 sm:text-base" data-id="element-41" data-mp="3dtfc3oi3qoog">
          You already know how to teach Art. THE COMPLETE ART YEAR™ simply gives you a stronger place
          to start—with lessons, projects, visual references and professional teaching tools ready for
          you to choose, adapt and use with your students.
        </p>
        <ul className="mt-6 grid w-full max-w-md gap-2.5 text-left sm:mt-8 sm:gap-3" data-id="element-42" data-mp="fkgt0xdo01q">
          {includes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-43" data-mp="5dvqnbnoaajy">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold/15 text-gold" data-id="element-44" data-mp="2l6bei4lc9cmp">
                <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-45" data-mp="2q78woh6cm6o7" />
              </span>
              <span className="text-sm leading-relaxed text-white/85" data-id="element-46" data-mp="wlnhf0ay0id5">{item}</span>
            </li>)}
        </ul>
        <p className="mt-6 text-base font-bold text-white sm:mt-8 sm:text-lg" data-id="element-47" data-mp="rodtjp37cerf">
          Choose the Focus. Open the Resource. Teach It Your Way.
        </p>
        <div className="mt-6 flex flex-col items-center sm:mt-8" data-id="element-48" data-mp="hykj4resq5or">
          <span className="text-lg font-medium text-white/40 line-through sm:text-xl" data-id="element-49" data-mp="hw83wm0fa9fe">$350 USD</span>
          <span className="font-display text-[52px] font-bold leading-none text-gold sm:text-7xl" data-id="element-50" data-mp="cwmtnffsyend">
            $27 USD
          </span>
        </div>
        <a href={CHECKOUT_URL} className="cta-button mt-6 flex min-h-[58px] sm:mt-9 w-full max-w-md items-center justify-center rounded-[10px] bg-gold px-6 py-4 text-base font-extrabold text-navy shadow-lg shadow-gold/25 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold sm:text-lg" data-id="element-51" data-mp="3zchlrv5ulhe">
          GET THE COMPLETE ART YEAR™
        </a>
        <p className="mt-3 text-xs text-white/60" data-id="element-52" data-mp="20xig9e8dr7fo">
          One-Time Payment · No Subscription · Instant Digital Access · Lifetime Access
        </p>
      </motion.div>
    </section>;
}